/* TODO: when c2CustomComponents is removed, we can simplify this to background and margin.
We can also remove the -webkit-scrollbar style as this is applied directly in CategoryTabs */
.categorySelector {
  display: flex;
  overflow: auto;
  flex-direction: row;
  align-items: center;
  gap: 24px;
  justify-content: flex-start;
  scrollbar-width: none; /* Firefox */
  background: var(--colors-background);
  margin: 24px var(--page-margin) 0;
}

.categorySelector::-webkit-scrollbar {
  display: none;
}

@media all and (--reefer-media-tablet-min) {
  .categorySelector {
    margin-left: var(--page-margin-desktop);
    margin-right: var(--page-margin-desktop);
  }
}
